import runes from 'runes';

export const maxWord = function (max, msg) {
    return this.test({
        name: 'maxWord',
        message: msg,
        test: (value) => {
            if (typeof value === 'undefined' || value === null) {
                return true;
            }
            return runes(value).length <= max;
        },
    });
};
